<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Disagreeing Virtuously: Religious Conflict in Interdisciplinary Perspective</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT" id="abb"><a id="page_xiii"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="table">
<tbody><tr>
<td><i>Acad.</i></td>
<td class="td1">Augustine, <i>Contra Academicos</i></td>
</tr>
<tr>
<td><i>Catech.</i></td>
<td class="td1">Augustine, <i>De catechizandis rudibus</i></td>
</tr>
<tr>
<td><i>Civ.</i></td>
<td class="td1">Augustine, <i>De civitate Dei</i></td>
</tr>
<tr>
<td><i>Doctr. chr.</i></td>
<td class="td1">Augustine, <i>De doctrina Christiana</i></td>
</tr>
<tr>
<td><i>Enchir.</i></td>
<td class="td1">Augustine, <i>Enchiridion</i></td>
</tr>
<tr>
<td><i>Ep.</i></td>
<td class="td1"><i>Epistulae</i></td>
</tr>
<tr>
<td>KRS</td>
<td class="td1">G. S. Kirk, J. E. Raven, and M. Schofield, <i>The Presocratic Philosophers: A Critical History with a Selection of Texts</i>. 2nd ed. Cambridge: Cambridge University Press, 1983 (numbers refer to fragments)</td>
</tr>
<tr>
<td><i>PA</i></td>
<td class="td1">St. Thomas Aquinas, <i>Sententia super Posteriora Analytica</i></td>
</tr>
<tr>
<td><i>ST</i></td>
<td class="td1">St. Thomas Aquinas, <i>Summa Theologiae</i></td>
</tr>
<tr>
<td><i>WA</i></td>
<td class="td1"><i>D. Martin Luthers Werke</i> [Weimarer Ausgabe]. Weimar: Böhlau, 1883–1993</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?22c16bcd